import { createRoot } from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import history from 'history/browser';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import { AbilityProvider } from '~/contexts/ability';
import { store } from '~/store';

import { App } from './App';
import { client } from './api/client.gen';

const container = document.getElementById('root');

client.setConfig({ credentials: 'include', baseUrl: import.meta.env.VITE_API_URL });

const Wrap = (
  <HelmetProvider>
    <Provider store={store}>
      <AbilityProvider>
        <HistoryRouter
          history={history as never}
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <App />
          </LocalizationProvider>
        </HistoryRouter>
      </AbilityProvider>
    </Provider>
  </HelmetProvider>
);

if (container) {
  createRoot(container).render(Wrap);
} else {
  throw new Error('No #root element in DOM');
}
